import { render, staticRenderFns } from "./dealerStock.vue?vue&type=template&id=42b77af2&scoped=true"
import script from "./dealerStock.vue?vue&type=script&lang=js"
export * from "./dealerStock.vue?vue&type=script&lang=js"
import style0 from "./dealerStock.vue?vue&type=style&index=0&id=42b77af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b77af2",
  null
  
)

export default component.exports